/**
 * VersionInfo Component
 * 버전 정보 및 저작권 표시
 *
 * @description
 * 페이지 하단에 표시되는 시스템 버전 및 저작권 정보
 */
import React, { memo, useMemo } from "react";

// ============================================================
// 상수 정의
// ============================================================

/** 기본 버전 */
const DEFAULT_VERSION = 'v1.0.0';

// ============================================================
// 타입 정의
// ============================================================

interface VersionInfoProps {
    /** 시스템 버전 */
    version?: string;
}

// ============================================================
// 컴포넌트 구현
// ============================================================

/**
 * 버전 정보 컴포넌트
 * @param props - VersionInfoProps
 */
const VersionInfo: React.FC<VersionInfoProps> = ({
    version = DEFAULT_VERSION
}) => {
    // 현재 연도 계산 (앱 실행 시점에 한 번만 계산)
    const currentYear = useMemo(() => new Date().getFullYear(), []);

    return (
        <div className="version-info">
            <p>VROONG 정산 시스템 {version}</p>
            <p>&copy; {currentYear} VROONG. All rights reserved.</p>
        </div>
    );
};

export default memo(VersionInfo);
